import clsx from "clsx";

import { Divider } from "@/components/common";
import { DefaultComponentProps } from "@/interfaces/common";

interface Props extends DefaultComponentProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
  titleClassName?: string;
  descriptionClassName?: string;
}

export const EmptyLayout = ({
  title,
  description,
  children,
  className,
  titleClassName,
  descriptionClassName,
}: Props) => {
  return (
    <div className="flex items-center justify-center h-full w-full max-h-[35rem]">
      <section
        className={clsx("flex w-full max-w-[37.5rem] flex-col items-center gap-6 bg-white p-10 md:p-20", className)}
      >
        <Divider type="icon" />

        <div className="flex flex-col items-center gap-2">
          <h3
            className={clsx("max-w-full text-center text-neutral-text break-words lg:text-[1.625rem]", titleClassName)}
          >
            {title}
          </h3>

          {description && (
            <p
              className={clsx(
                "max-w-full text-center text-sm font-light text-neutral-text break-words",
                descriptionClassName,
              )}
            >
              {description}
            </p>
          )}
        </div>

        {children}
      </section>
    </div>
  );
};
